import { PostingPlanAdapters } from '../adapters';
import { PermanentJobsApi } from '../clients';
import { IGetPostingPlansResult } from '../types';

export const getPostingPlans = async (): Promise<IGetPostingPlansResult> => {
  const response = await PermanentJobsApi.getPostingPlans();

  return PostingPlanAdapters.toGetPostingPlansResult(response);
};
